import Button from '@material-ui/core/Button';
import Card from '../../../../components/Card/CardTS';
import CardBody from '../../../../components/Card/CardBody.js';
import CardHeader from '../../../../components/Card/CardHeader.js';
import CardIcon from '../../../../components/Card/CardIcon.js';
import React, {useEffect} from 'react';
import regularFormsStyle from '../../../../assets/jss/material-dashboard-pro-react/views/regularFormsStyleTS';
import { ClassNameMap } from '@material-ui/core/styles/withStyles';
import { useState} from 'react';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import { deleteSystem } from '../../../stores/actions/installerActions';
import { getVisibleSystemsForAccountShort } from  '../../../stores/actions/accountActions';
import { getNodes } from '../../../stores/actions/actions';
import { connect } from 'react-redux';
import Person from '@material-ui/icons/Person';
import { ISystem, INode } from '../../../helpers/interfaces';
import Autocomplete from '@material-ui/lab/Autocomplete';
import SweetAlert from 'react-bootstrap-sweetalert';
import { sweetAlertStyle } from '../../../helpers/CustomStyles';
import RemoveNodeConfirmationCard from '../../../components/RemoveNodeConfirmationCard/RemoveNodeConfirmationCard';
import _ from 'lodash';
import '../InstallerPanel.css';

interface IDeleteNodeFromSystemProps {
    classes: ClassNameMap;
    mobileView: boolean;
    deleteSystem: (systemID) => void;
    getNodes: (nodeID) => void;
    systems: ISystem[];
    nodes: INode[];
}

const DeleteNodeFromSystem = ({
    mobileView,
    deleteSystem,
    getNodes,
    systems,
    nodes,
    ...props
}: IDeleteNodeFromSystemProps) => {
    const { classes } = props;
	const [pickedSystem, setPickedSystem] = useState<number|null|undefined>(null);
    const [pickedNode, setPickedNode] = useState<number|null|undefined>(null);
    const systemIds = systems.map(el => el.ID);
    const nodeIds = nodes.map(el => el.id);
    const systemNamesByIds = Object.fromEntries(systems.map(x => [x.ID, x.name]));
    const nodeNamesByIds = Object.fromEntries(nodes.map(x => [x.id, x.name]));
    const [confirmationWindow, setConfirmationWindow] = useState<any>(null);
 
	useEffect(() => {
        getNodes([pickedSystem]);
	}, [pickedSystem]);

 
    const handleDeleteNodeFromSystem = (): void => {
        if (pickedNode) {
            showRemoveSystemConfirmation();
        }
    }
    const deleteButton = (): JSX.Element => {
        return (
            <Button
                size='medium'
                style={{ marginTop: '25px', transition: 'color 0.3s' }}
                disabled={!pickedNode}
                onClick={(e) => { handleDeleteNodeFromSystem() }}
            >
                Delete
            </Button>
        );
    };
	const hideRemoveNodeConfirmation = () => {
		setConfirmationWindow(null);
	};

	const showRemoveSystemConfirmation = (): void => {
        const node =  _.filter(nodes, { id: pickedNode })[0];
		setConfirmationWindow(
			<SweetAlert
				title=''
				showConfirm={false}
				style={sweetAlertStyle}
				onConfirm={hideRemoveNodeConfirmation}
				onCancel={hideRemoveNodeConfirmation}
				key='remove-system-confirmation-alert'
			>
				<RemoveNodeConfirmationCard node={node} hideRemoveNodeConfirmation={hideRemoveNodeConfirmation} />
			</SweetAlert>
		);
	};

    if (systems.length < 1) {
        return (
            <Card>
                <CardHeader color='info' icon>
                    <CardIcon color='info'>
                        <Person />
                    </CardIcon>
                    <h4 className={classes.cardIconTitle}>
                        Delete Node from System
                    </h4>
                </CardHeader>
                <CardBody>Please add a system first.</CardBody>
            </Card>
        );
    }

    return (
        <>
        {confirmationWindow}
        <Card className='inviteUserForm'>
            <CardHeader color='info' icon>
                <CardIcon color='info'>
                    <Person />
                </CardIcon>
                <h4 className={classes.cardIconTitle}>Delete Node from System</h4>
            </CardHeader>
            <CardBody>
                <FormControl fullWidth className={classes.selectFormControl} onSubmit={(e) => e.preventDefault()}>
                    <div style={{ width: '100%' }}>
                        <Autocomplete
                            options={systemIds}
                            getOptionLabel={(id) => systemNamesByIds[id]}
                            id='system-name'
                            value={pickedSystem}
                            onChange={(e, newVal) => setPickedSystem(newVal)}
                            renderInput={(systemIds) => <TextField {...systemIds} label='Systems' margin='normal' />}
                            style={{ width: '100%' }}
                        />
                    </div>
                    <div style={{ width: '100%' }}>
                        <Autocomplete
                            options={nodeIds}
                            getOptionLabel={(id) => nodeNamesByIds[id]}
                            disabled={!pickedSystem}
                            id='node-name'
                            value={pickedNode}
                            onChange={(e, newVal) => setPickedNode(newVal)}
                            renderInput={(nodeIds) => <TextField {...nodeIds} label='Nodes' margin='normal' />}
                            style={{ width: '100%' }}
                        />
                    </div>
                </FormControl>
                {deleteButton()}
            </CardBody>
        </Card>
        </>
    );
};

const mapStateToProps = (state) => ({
    systems: state.installer.systemsForInstallerPanel || [],
    nodes: state.dashboard.nodes,
    mobileView: state.dashboard.mobileView,
});
const actions = {
    getVisibleSystemsForAccountShort,
    deleteSystem,
    getNodes
};

const DeleteNodeFromSystemWithStyles = regularFormsStyle(DeleteNodeFromSystem);
export default connect(mapStateToProps, actions)(DeleteNodeFromSystemWithStyles);
